import { render, staticRenderFns } from "./add-customer.vue?vue&type=template&id=4f463a3e&scoped=true"
import script from "./add-customer.vue?vue&type=script&lang=js"
export * from "./add-customer.vue?vue&type=script&lang=js"
import style0 from "./add-customer.vue?vue&type=style&index=0&id=4f463a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f463a3e",
  null
  
)

export default component.exports